import { createVNode as e, mergeProps as a } from "vue";
import n from "../node_modules/@pf-ui/pf-icon-svg/es/asn/ReconciliationFilledStandard.js";
import l from "../components/PfIcon.js";
const t = (i, o) => {
  const r = {
    ...i,
    ...o.attrs
  };
  return e(l, a(r, {
    icon: n
  }), null);
};
t.displayName = "ReconciliationFilledStandard";
t.inheritAttrs = !1;
export {
  t as default
};
